export default "__VITE_ASSET__4748e168__"